// extracted by mini-css-extract-plugin
module.exports = {"body":"InputAddStable_body__3tW2B","paste":"InputAddStable_paste__3SpD2"};